export default __webpack_public_path__ + "static/media/key_256.861d04b5.png";